import { cloneDeep } from 'lodash';
const SET_ENROLL_SHIPPING_SUCCESS = 'SET_ENROLL_SHIPPING_SUCCESS';
const SET_ENROLL_SHIPPING_SUCCESS_FALSE = 'SET_ENROLL_SHIPPING_SUCCESS_FALSE';

const initialStateEnrollShipping = false;

export default function reducer(state = cloneDeep(initialStateEnrollShipping), action) {
	switch (action.type) {
		case SET_ENROLL_SHIPPING_SUCCESS:
			return true;
		case SET_ENROLL_SHIPPING_SUCCESS_FALSE:
			return false;
		default:
			return state;
	}
}

export function fireEnrollShippingSuccess(){
	return { type: SET_ENROLL_SHIPPING_SUCCESS }
}

export function clearEnrollShippingSuccess(){
	return { type: SET_ENROLL_SHIPPING_SUCCESS_FALSE }
}



// WEBPACK FOOTER //
// ./src/modules/enroll_shipping_success.js